import { Button, Container, Grid, Paper, styled } from '@mui/material';
import React, { useState } from 'react';
import { ButtonOperation } from "./buttons/operation";
import { ButtonDigit } from "./buttons/digit"

const CalculatorOutput = styled("div")(
  ({ theme }) => (
    {
      width: "100%",
      textAlign: "right",
      height: "2em",
      padding: theme.spacing(2),
      fontSize: "3em",
      overflow: "hidden"
    }
  )
)

const CalculatorBase = styled(Paper)(
  ({ theme }) => (
    {
      padding: theme.spacing(2), 
      marginTop: theme.spacing(4),
      borderRadius: 15
    }
  )
)

function App() {
  const [valueCurrent, setValueCurrent] = useState("0");
  const [valuePrevious, setValuePrevious] = useState("");
  const [operation, setOperation] = useState("");
  const [overwrite, setOverwrite] = useState(true);
  
  const allClear = () => {
    setValuePrevious("");
    setValueCurrent("0");
    setOperation("");
    setOverwrite(true);
  }
  const clear = () => {
    setValueCurrent("0");
    setOverwrite(true);
  }
  const percent = () => {
    setValueCurrent((parseFloat(valueCurrent) / 100).toString());
  }
  const compute = () => {
    if (!valuePrevious || !operation) return valueCurrent;
    const previous = parseFloat(valuePrevious);
    const current = parseFloat(valueCurrent);
    let result;
    switch (operation) {
      case "/":
        result = previous / current;
        break;
      case "*":
        result = previous * current;
        break;
      case "-":
        result = previous - current;
        break;
      case "+":
        result = previous + current;
        break;
    }
    return result;
  }
  const equals = () => {
    const result = compute();
    setValueCurrent(`${result}`);
    setValuePrevious("");
    setOperation("");
    setOverwrite(true);
  }

  const enterDigit = (digit: string) => {
    if (valueCurrent[0] === "0" && digit === "0") return;
    if (valueCurrent.includes(".") && digit == ".") return;
    if (overwrite && digit !== ".") {
      setValueCurrent(digit);
    } else {
      setValueCurrent(`${valueCurrent}${digit}`);
    }
    setOverwrite(false);
  }
  const enterOperation = (operation : string) => {
    setValuePrevious(valueCurrent);
    setOperation(operation);
    setOverwrite(true);
  }

  return (
    <Container maxWidth="sm">
      <CalculatorBase elevation={ 3 }>
        <Grid container spacing={ 1 }>
          <Grid item xs={ 12 }>
            <CalculatorOutput>
              { valueCurrent }
            </CalculatorOutput>
          </Grid>
          <Grid item container columnSpacing={ 1 }>
            <ButtonOperation operation={ "AC" } enterOperation={ allClear } enteredOperation={ operation } />
            <ButtonOperation operation={ "C" } enterOperation={ clear } enteredOperation={ operation } />
            <ButtonOperation operation={ "%" } enterOperation={ percent } enteredOperation={ operation } />
            <ButtonOperation operation={ "/" } enterOperation={ enterOperation } enteredOperation={ operation } />
          </Grid>
          <Grid item container columnSpacing={ 1 }>
            <ButtonDigit digit={ "7" } enterDigit={ enterDigit } />
            <ButtonDigit digit={ "8" } enterDigit={ enterDigit } />
            <ButtonDigit digit={ "9" } enterDigit={ enterDigit } />
            <ButtonOperation operation={ "*" } enterOperation={ enterOperation } enteredOperation={ operation } />
          </Grid>
          <Grid item container columnSpacing={ 1 }>
            <ButtonDigit digit={ "4" } enterDigit={ enterDigit } />
            <ButtonDigit digit={ "5" } enterDigit={ enterDigit } />
            <ButtonDigit digit={ "6" } enterDigit={ enterDigit } />
            <ButtonOperation operation={ "-" } enterOperation={ enterOperation } enteredOperation={ operation } />
          </Grid>
          <Grid item container columnSpacing={ 1 }>
            <ButtonDigit digit={ "1" } enterDigit={ enterDigit } />
            <ButtonDigit digit={ "2" } enterDigit={ enterDigit } />
            <ButtonDigit digit={ "3" } enterDigit={ enterDigit } />
            <ButtonOperation operation={ "+" } enterOperation={ enterOperation } enteredOperation={ operation } />
          </Grid>
          <Grid item container columnSpacing={ 1 }>
            <ButtonDigit digit={ "0" } enterDigit={ enterDigit } xs={ 6 }/>
            <ButtonDigit digit={ "." } enterDigit={ enterDigit } />
            <Grid item xs = { 3 }>
              <Button fullWidth variant="contained" onClick={ equals }>=</Button>
            </Grid>
          </Grid>
        </Grid>
      </CalculatorBase>
    </Container>
  );
}

export default App;
